import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteSpotsService = async (spotId: string): Promise<void> => {
  await jhsfBookingsApi.delete(`/spots/${spotId}`);
};

export default deleteSpotsService;
